var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.206,
    height: 17.999,
    viewBox: "0 0 13.206 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3037",
    "data-name": "Rectangle 3037",
    width: 13.206,
    height: 17.999,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10690",
    "data-name": "Group 10690",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10689",
    "data-name": "Group 10689",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28442",
    "data-name": "Path 28442",
    d: "M.052,5.13A.682.682,0,0,0,.2,5.358l4.169,4.17a.695.695,0,0,0,.983-.983L2.372,5.561H12.51a.7.7,0,0,0,0-1.39H2.372L5.356,1.187A.695.695,0,0,0,4.373.2L.2,4.374A.682.682,0,0,0,.052,4.6l0,.01a.675.675,0,0,0,0,.508l0,.01",
    transform: "translate(0.001 0)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28443",
    "data-name": "Path 28443",
    d: "M13.153,22.446A.7.7,0,0,0,13,22.218l-4.17-4.17a.695.695,0,0,0-.983.983l2.984,2.984H.7a.7.7,0,1,0,0,1.39H10.833L7.849,26.389a.695.695,0,1,0,.983.983L13,23.2a.689.689,0,0,0,.152-.228l0-.011a.673.673,0,0,0,0-.507l0-.011",
    transform: "translate(0 -9.576)",
    fill: "#161615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartExchange);
export default __webpack_public_path__ + "static/media/partExchange.618f2df89711a337dc6a6657efed9df5.svg";
export { ForwardRef as ReactComponent };